// Перехоплювач API запитів для централізованої обробки помилок
(function() {
  const originalFetch = window.fetch;

  window.fetch = async function(...args) {
    try {
      const response = await originalFetch(...args);
      
      // Обробка помилок доступу та сесії
      if (response.status === 401 || response.status === 403) {
        // Якщо це не запит на login.php (щоб уникнути зациклення)
        const url = typeof args[0] === 'string' ? args[0] : (args[0] instanceof Request ? args[0].url : String(args[0]));
        if (!url.includes('login.php')) {
          console.warn(`[API] Сесія завершена або доступ заборонено (${response.status})`);
          if (typeof showMessage === 'function') {
            showMessage("Ваша сесія закінчилася або доступ заборонено. Будь ласка, увійдіть знову.", "error");
          }
          // Даємо час на показ повідомлення перед редіректом
          setTimeout(() => {
            window.location.href = "login.html";
          }, 2000);
        }
      }

      // Обробка Rate Limiting (забагато запитів)
      if (response.status === 429) {
        console.warn(`[API] Забагато запитів (429)`);
        if (typeof showMessage === 'function') {
          showMessage("Забагато запитів. Будь ласка, зачекайте хвилинку.", "warning");
        }
      }

      // Серверні помилки
      if (response.status >= 500) {
        console.error(`[API] Помилка сервера ${response.status}`);
        if (typeof showMessage === 'function') {
          showMessage("Помилка на сервері. Спробуйте пізніше.", "error");
        }
      }

      return response;
    } catch (error) {
      // Обробка мережевих помилок (відсутність інтернету тощо)
      console.error("[API Network Error]", error);
      if (typeof showMessage === 'function') {
        showMessage("Помилка з'єднання. Перевірте інтернет.", "error");
      }
      throw error;
    }
  };
})();
